<template>
    <div v-if="!showDetails" class="container">
        <div class="header">
            <div class="heading">
                <p class="title">{{actionType}} Approval</p>
            </div>
            <p v-if="role === 'BRAND'" class="download" @click="downloadAgencies">View Linked Agencies </p>
        </div>
        <div class="userManagement">
            <div v-if="apiErrorMessage" class="errorContainer"> 
                <div class="errorHeading">Error</div>
                <div class="apiErrorMessage">{{ apiErrorMessage }}</div>
            </div>
            <table class="table">
                <thead style="background: #F5F5F5">
                    <tr>
                        <th class="tableHead">Agency Name</th>
                        <th v-if="actionType === 'De-Link'" class="tableHead">Brand Name</th>
                        <th>Requested by</th>
                        <th>Timestamp<img alt="img" style="cursor: pointer"
                                                @click="onSortClick" src="../../assets/Vector.svg" /></th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in filteredItems" :key="item.agencyId">
                        <td>
                            <div style="font-size: 12px; font-weight: 600; color: #41434C"> {{ item.agencyName }} </div>
                            <div style="font-size: 12px; margin-top: 4px">Email ID: {{ item.agencyId }} </div>
                        </td>
                        <td v-if="actionType === 'De-Link'">
                            <div style="font-size: 12px; font-weight: 600; color: #41434C"> {{ item.brandName }} </div>
                            <div style="font-size: 12px; margin-top: 4px">ID: {{ item.brandId }} </div>
                        </td>
                        <td>{{ item.requestedBy }}</td>
                        <td>{{ formatDate(item.timeStamp) }}</td>
                        <td>
                            <button class="linkBtn" @click="onActionClick(item)"> {{actionType}} </button>
                            <span v-if="actionType === 'Link'"> or </span>
                            <button v-if="actionType === 'Link'" class="linkBtn" style="color: #EB5757" @click="onActionClick(item, true)"> Reject </button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="paginate">
                <div class="rows">
                    <span class="paginationText">Page {{ currentPage }} of {{ isNaN(totalPages) ? 1 :
                        totalPages }}</span>
                    <div class="flexClass">
                        <p class="paginationText">Rows per page</p>
                        <select class="limit" v-model="rowsPerPage" @change="onRowsPerPageChanged">
                            <option v-for="option in options" v-bind:key="option" :value="option">{{ option }}
                            </option>
                        </select>
                        <img alt="img" v-if="currentPage > 1" @click="prevPage" class="leftArrow"
                            src="../../assets/leftArrow.svg" />
                        <img alt="img" v-else class="leftArrowDisabled" src="../../assets/leftArrow.svg" />
                        <img alt="img" v-if="currentPage < totalPages" @click="nextPage" class="rightArrow"
                            src="../../assets/rightArrow.svg" />
                        <img alt="img" v-else class="leftArrowDisabled" src="../../assets/rightArrow.svg" />
                    </div>
                </div>
            </div>
        </div>
        <ConfirmationModal v-if="showConfirmationModal"
            :title="`Link ${showConfirmationModal == 'APPROVED' ? 'Approval' : 'Rejection'}`"
            :subTitle="`Are you sure you want to ${showConfirmationModal == 'APPROVED' ? 'approve' : 'reject'} ${selectedItem.agencyName}?`"
            :leftButton="'Cancel'"
            :rightButton="'Yes'"
            @cancelClicked="handleCloseModal"
            @buttonClicked="onConfirmClick"
        />
    </div>
    <div v-else>
        <Delink :item="selectedItem" :viewMode="showDetails" @backClicked="removeViewMode" />
    </div>
</template>

<script>
import { getCookie } from '@/services/campaignService';
import { agencyBrandLink, getDeLinkList, getLinkedAgencies, getLinkList } from '@/services/selfServeService';
import moment from 'moment';
import { toRaw } from 'vue';
import ConfirmationModal from '../ConfirmationModal';
import Delink from './Delink'
import Link from './Link';

export default ({
    name: 'LinkDelink',
    components: {
        Delink,
        Link,
        ConfirmationModal
    },
    data() {
        return {
            actionType: '',
            items: [],
            currentPage: 1,
            rowsPerPage: 10,
            showDetails: false,
            filterChanged: false,
            filteredData: [],
            sortClicked: false,
            options: [10, 20, 50, 100],
            selectedItem: null,
            apiErrorMessage: null,
            showConfirmationModal: '',
            role: ''
        }
    },
    mounted() {
        this.role = getCookie('role');
        this.actionType = (getCookie('role') == 'SUPERADMIN' ? 'De-Link' : 'Link');
        this.getList()
    },
    methods: {
        onActionClick(item, reject) {
            this.apiErrorMessage = null;
            this.selectedItem = item;
            if(this.actionType === 'De-Link') {
                this.showDetails = true;
            } else {
                this.showConfirmationModal = reject ? 'REJECTED' : 'APPROVED';
            }
        },
        formatDate(value) {
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD HH:mm:ss');
            }
            return value
        },
        onConfirmClick() {
            const payload = {
                agencyId: this.selectedItem.agencyId,
                approvalStatus: this.showConfirmationModal,
            }
            agencyBrandLink(payload)
                .then(res => res.json())
                .then(data => {
                    this.showConfirmationModal = ""
                    if(data.code == 200) {
                        this.getList();
                    } else {
                        this.apiErrorMessage = data?.errors?.[0] || data?.message
                    }
                })
                .catch(data => {
                    this.showConfirmationModal = ""
                    this.apiErrorMessage = data?.errors?.[0] || data?.message
                })
        },
        handleCloseModal() {
            this.showConfirmationModal = ""
        },
        onSortClick() {
            this.sortClicked = !this.sortClicked;
            this.filteredData?.sort((a, b) => {
                    let dateA = new Date(a.timeStamp) ;
                    let dateB = new Date(b.timeStamp) ;
                    return this.sortClicked ? dateB - dateA :  dateA - dateB;
            })
        },
        removeViewMode() {
            this.showDetails = false;
            this.getList();
        },
        nextPage() {
            this.currentPage++
        },
        prevPage() {
            this.currentPage--
        },
        async getList() {
            if(this.actionType === 'Link') {
                await getLinkList()
                    .then(res => res.json())
                    .then(data => {
                        if(data.code == 200) {
                            this.items = data?.data;
                            this.filteredData = data?.data;
                        } else {
                            this.apiErrorMessage = data?.errors?.[0] || data?.message
                        }
                    })
                    .catch(error => {
                        this.apiErrorMessage = error?.errors?.[0] || error?.message
                    })
            } else {
                await getDeLinkList()
                    .then(res => res.json())
                    .then(data => {
                        if(data.code == 200) {
                            this.items = data?.data;
                            this.filteredData = data?.data;
                        } else {
                            this.apiErrorMessage = data?.errors?.[0] || data?.message
                        }
                    })
                    .catch(error => {
                        this.apiErrorMessage = error?.errors?.[0] || error?.message
                    })
            }
        },
        async downloadAgencies() {
            this.apiErrorMessage = null;
            const brandId = getCookie('userId')
            await getLinkedAgencies(brandId)
                    .then(res => res.json())
                    .then(data => {
                        if(data.code == 200) {
                            const content = [{agencyId: 'Agency Email ID', agencyName: 'Agency Name'}, ...data?.data]
                            const csvContent = "data:text/csv;charset=utf-8," +
                            content?.map(row => Object.values(row).join(',')).join('\n');
                            const link = document.createElement('a');
                            link.href = encodeURI(csvContent);
                            link.target = '_blank';
                            link.download = `agencies.csv`;
                            link.click();
                        } else {
                            this.apiErrorMessage = data?.errors?.[0] || data?.message
                        }
                    })
                    .catch(data => {
                        this.apiErrorMessage = data?.errors?.[0] || data?.message
                    })
        }
    },
    computed: {
        totalPages() {
            let newpages = 0;
            if (this.filterChanged) {
                newpages = Math.ceil(toRaw(this.filteredData)?.length / this.rowsPerPage)
            } else {
                newpages = Math.ceil(toRaw(this.items)?.length / this.rowsPerPage)
            }

            if (this.currentPage !== 1 && this.currentPage > this.totalPages) {
                this.currentPage = this.totalPages;
            }
            newpages = Math.max(newpages, 1);
            return newpages;
        },
        filteredItems() {
            let pageNumber = this.currentPage === 0 ? 1 : this.currentPage;
            const start = (pageNumber - 1) * this.rowsPerPage;
            const end = start + this.rowsPerPage;
            return this.filteredData?.slice(start, end);
        },
        onRowsPerPageChanged() {
            const oldRowsPerPage = this.rowsPerPage;
            this.rowsPerPage = Number(event.target.value);
            this.totalPages = Math.ceil(this.campaigns?.length / this.rowsPerPage);
            if (this.currentPage > this.totalPages) {
                this.currentPage = this.totalPages;
            }
            if (oldRowsPerPage !== this.rowsPerPage) {
                this.$nextTick(() => {
                    const newPage = Math.floor(((this.currentPage - 1) * oldRowsPerPage) / this.rowsPerPage) + 1;
                    this.currentPage = newPage;
                });
            }
        },
    }
})
</script>

<style scoped>
    .container {
        font-family: 'Inter-Regular';
        background: #F8F8F8;
        display: flex;
        flex-direction: column;
    }
    .header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-family: 'Inter-Regular';
        font-style: normal;
        font-weight: 600;
        line-height: 140%;
        color: #401D0C;
        padding: 8px 20px 0px;
        margin-left: 0;
        background: #FFFFFF;
    }
    .title{
        margin-left:20px;
    }

    .heading {
        display: flex;
        flex-direction: row;
        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        line-height: 140%;
        color: #333333;
        margin: 0;
    }
    .btnWrapper {
        display: flex;
        align-items: center;
        flex-direction: row;
    }
    .submitBtn {
        background: #2E31BE;
        border-radius: 4px;
        color: #FFFFFF;
        padding: 9px 16px;
        cursor: pointer;
    }
    .userManagement {
        display: flex;
        flex-direction: column;
        margin: 1%;
        text-align: start;
        background: #FFFFFF;
        padding: 22px 24px 36px;
        border-radius: 12px;
    }
    .subHeading {
        display: flex;
        justify-content: space-between;
    }
    .userType {
        width: 200px;
        height: 40px;
        padding: 8px 12px 8px 12px;
        border-radius: 4px 0px 0px 0px;
        border: 1px solid #E0E0E0;
        font-family: Inter-Regular;
        font-size: 12px;
        font-weight: 400;
        line-height: 19.2px;
        text-align: left;
    }
    .btnWrapper {
        display: flex;
        align-items: center;
        flex-direction: row;
    }
    .submitBtn {
        background: #2E31BE;
        border-radius: 4px;
        color: #FFFFFF;
        padding: 9.5px 16px;
        cursor: pointer;
        font-size: 14px;
    }
    table {
        width: 100%;
        border-collapse: collapse;
        margin: 20px 0;
        font-size: 18px;
        text-align: left;
    }

    th {
        color: #41434C;
        padding: 12px 15px;
        /* width: 150px; */
        font-size: 14px;
        font-weight: 600;
    }
    td {
        padding: 12px 15px;
        height: 40px;
        font-size: 14px;
        font-weight: 400;
        color: #5C5C5C;
        width: 150px;
    }

    thead tr {
        text-align: left;
        font-weight: bold;
    }

    tbody tr {
        border-bottom: 1px solid #dddddd;
    }

    tbody tr:nth-of-type(even) {
        background-color: #F5F8FF;
    }
    .paginate {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 16px 24px;
        gap: 715px;
        height: 66px;
        left: 274px;
        top: 775px;
        background: #FFFFFF;
        border: 1px solid #F8F8F8;
        width: -webkit-fill-available;
    }
    .rows {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.flexClass {
    display: flex;
}

.limit {
    display: flex;
    margin-left: 20px;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #666666;
    border: 1px solid #EEEEEE;
    border-radius: 4px;
    padding: 10px 8px 10px 12px;
}

.leftArrow {
    display: flex;
    margin-left: 24px;
    cursor: pointer;
}

.leftArrowDisabled {
    display: flex;
    margin-left: 20px;
    opacity: 0.4;
    cursor: not-allowed;
}

.rightArrow {
    display: flex;
    margin-left: 20px;
    cursor: pointer;
}
.paginationText {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #9B9B9B;
}
.linkBtn {
    border: none;
    background: none;
    cursor: pointer;
    font-weight: 700;
    color: #2E31BE;
}
.errorHeading{
    font-weight: 700;
    font-size: 14px;
    line-height: 140%;
    color: #EB5757;
    display: flex;
}

.apiErrorMessage{
    font-weight: 400;
    font-size: 12px;
    line-height: 140%;
    color: #666666;
    margin-top: 12px;
    margin-bottom: 24px;
}
.download {
    cursor: pointer;
    margin-right: 24px;
    color: #2E31BE;
    font-size: 14px;
}
</style>
